export default __webpack_public_path__ + "static/media/SalesAnalyticsMobile.793135d1.png";